// eslint-disable-next-line
// import styles from './Memos.module.css'

import React from 'react'

import SimplePopUp from '../../shared/SimplePopUp/SimplePopUp'
import SimpleDeletePopUp from '../../shared/SimpleDeletePopUp/SimpleDeletePopUp'
import MemoForm from './MemoForm'
import AllInboxIcon from '@material-ui/icons/AllInbox';

import axios from 'axios'
import PropTypes from 'prop-types'

import AlertMessage from "../../shared/Notify/AlertMessage";
import ProgressBar from "../../shared/ProgressBar/ProgressBar";
import AnnouncementTable from '../Announcements/AnnouncementTable'
import {Redirect} from 'react-router-dom'
import MemoSearchForm from './MemoSearchForm'
import { withRouter } from 'react-router-dom'
import Cookies from 'js-cookie';
import Memo from './Memo';

export const Component = withRouter(() => {

})
class Memos extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      model: 'incident_report',
      memos: [],
      openPopup: false,
      openDeletePopup: false,
      memo: {},
      employees: [],
      selectedEmployees: [],
      initialMemo: { id: '', content: '',title: '' },
      title: '',
      load: false,
      tableHead: ['title','officer_name',"employee_names"],
      withShow: false,
      withEdit: true,
      mdWidth: 'md',
      error_messages: '',
      notify: {  },
      isOpen: false,
      message: '',
      type: '',
      redirectToShow: false,
      searchMemo: {
        employee: {}
      },

      totalPages: 1,
      currentPage: 1,
      withPagination: true,
      totalResults: 0,
      withResultsLabel: false,
      approvingOfficers: [],
      officer: {},
      showPopup: false,
      errorMessages: {},
      searchUrl: '/v1/memos/search',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleCreateorUpdateItem = this.handleCreateorUpdateItem.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleOpenDeletePopup = this.handleOpenDeletePopup.bind(this)
    this.handleDeleteClose = this.handleDeleteClose.bind(this)
    this.handleCloseAlert = this.handleCloseAlert.bind(this)
    this.handleAutocomplete=this.handleAutocomplete.bind(this)
    this.handleEditor = this.handleEditor.bind(this)
    this.rowClick=this.rowClick.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.search = this.search.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
    this.handleEmployees = this.handleEmployees.bind(this)
    this.onAttachmentAdd = this.onAttachmentAdd.bind(this)
    this.handleShowPopup = this.handleShowPopup.bind(this)
  }

  componentDidMount () {
    var searchUrl = this.state.searchUrl + this.props.location.search
    var searchParams = {}
    const params = new URLSearchParams(this.props.location.search)
    // This is to load all params based on URLSearchParams
    params.forEach(function(value, key) {
      if (key !== 'page') {
        if(key === 'name' || key === 'content'|| key === 'title') {
          searchParams[key] = value.replace(/\*/g,'')
        }else if(key === 'employee_ids'){
          axios({
            method: 'get',
            url: '/v1/employees/'+value,
            headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
          }).then(resp => {
            searchParams["employee"]=resp.data
          })
        }
        else {
          searchParams[key] = value
        }
      }
    })
    this.setState({ searchMemo: searchParams })
    this.loadMemos(searchUrl)
  }

  loadMemos (url) {
    axios({
      method: 'get',
      url: url,
      headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
    }).then(resp => {

      this.setState({ memos: resp.data.memos })
      this.setState({ currentPage: resp.data.meta.current_page})
      this.setState({ totalResults: resp.data.meta.total_count})
      this.setState({ totalPages: resp.data.meta.total_pages })

      axios({
        method: 'get',
        url: '/v1/employees/search?is_active=true&per_page=50000',
        headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
      }).then(resp => {
        this.setState({ employees: resp.data.employees })
        this.setState({ load: true })
      }).catch(error => console.log(error.response))
    }).catch(error => console.log(error.response))
    if(Cookies.get('current_user')){
      if(JSON.parse(Cookies.get('current_user')).is_employee){
      axios({ 
        method: 'get',
        url: '/v1/employees/approving_officers',
        headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
      }).then(resp => {
        this.setState({ approvingOfficers: resp.data })
        })
      }
    }
  }

  handleSubmit () {
    const item = this.state.memo
    item['officer_id']= this.state.officer.id
    var method = ''
    var url = ''
    var empIds = []
    if(this.state.selectedEmployees.length>0){
     this.state.selectedEmployees.map((emp)=>{
         empIds.push(emp.id)
     })
    }
    item["employee_ids"]=empIds
    if (item.id === '') {
      method = 'post'
      url = '/v1/memos'
    } else {
      method = 'put'
      url = '/v1/memos/' + item.id
    }
    axios({
      method: method,
      url: url,
      data: (item),
      headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
    }).then(resp => {
      const newData = resp.data
      this.setState({
        memos: this.state.memos.filter(memo => memo.id !== item.id)
      })
      this.setState({ memos: [...this.state.memos, newData] })
      this.setState({ openPopup: false })
      this.setState({
        isOpen: true,
        message: 'Submitted Successfully',
        type: 'success'
      })
    }).catch(error => {
      if (error.response.status === 422) {
        var errors = {}
				Object.keys(error.response.data.errors[0].detail.errors).map((field) => {
					errors[field] = error.response.data.errors[0].detail.errors[field][0]
					if (field.includes('.')) {
						errors[field.split(".")[1]] = error.response.data.errors[0].detail.errors[field][0]
					} else {
						errors[field] = error.response.data.errors[0].detail.errors[field][0]
					}
				})
				this.setState({ errorMessages: errors })
      } else {
        this.setState({
          isOpen: true,
          message: error.response.status.toString() + " Unexpected Error Problem Occurred",
          type: 'error'
        })
        this.setState({openPopup: false})
      }
    })
  }

  uploadAttachment(attachment) {
    var file = attachment.file;
    var form = new FormData;
    var endpoint = '/v1/photos/'
    form.append("Content-Type", file.type);
    form.append("image", file);

    form.append('title',file.name)
    form.append('description', 'test2')
    form.append('rank', 12)
    form.append('publish', false)

   const xhr = new XMLHttpRequest;
    xhr.open("POST", endpoint, true);
    xhr.setRequestHeader('X-API-ACCESS-TOKEN', localStorage.getItem('api_key'));

    xhr.upload.onprogress = function (event) {
        var progress = event.loaded / event.total * 100;
        return attachment.setUploadProgress(progress);
    };

    xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
            var data = JSON.parse(this.responseText);
            return attachment.setAttributes({
                url: data.image.normal,
                href: data.image.normal
            });
        }
    }
    return xhr.send(form)
  }
  onAttachmentAdd(event) {
    var attachment = event.attachment;
    if (attachment.file) {
        return this.uploadAttachment(attachment);
    }
}

  handleDeleteItem () {
    const DeleteItemId = this.state.memo.id
    axios({
      method: 'delete',
      url: '/v1/memos/' + DeleteItemId,
      headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
    }).then(() => {
      this.setState({
        memos: this.state.memos.filter(item => item.id !== DeleteItemId)
      })
      this.setState({ openDeletePopup: false })
      this.setState({
        isOpen: true,
        message: 'Deleted Successfully',
        type: 'error'
      })
    }).catch(error => console.log(error.response))
  }

  handleClose () {
    this.setState({ openPopup: false, showPopup: false})
    this.setState({ openDeletePopup: false })
    this.setState({ error_messages: ''})
  }

  handleCreateorUpdateItem (item, isAdd, model) {
    var textTitle = ''
    var selectedEmployees = []
    if (isAdd) {
      textTitle = 'Create ' + model
    } else {
      textTitle = 'Edit ' + model
      if(this.state.employees.length>0){
          if(item.employee_ids.length>0){
              item.employee_ids.map((empId)=>{
                  this.state.employees.map((emp)=>{
                      if(empId===emp.id){
                          selectedEmployees.push(emp)
                      }
                  })
              })
          }
      }
    }
    this.setState({ selectedEmployees: selectedEmployees})
    this.setState({ openPopup: true })
    this.setState({ memo: item })
    this.setState({ title: textTitle })
  }

  handleInputChange (e) {
    this.setState({
      memo: {
        ...this.state.memo,
        [e.target.name]: e.target.value
      }
    })
  }

  handleOpenDeletePopup (item, model) {
    this.setState({ model: model })
    this.setState({ memo: item })
    this.setState({ openDeletePopup: true })
  }

  handleDeleteClose () {
    this.setState({ openDeletePopup: false })
  }

  handleCloseAlert (event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({isOpen: false})
  }
  handleAutocomplete(event,values){
    if(event.target.id.includes('employees')){
      this.setState({selectedEmployees: values})
    }
    else{
      this.setState({officer: values})
    }
      
  }

  handleEditor(event, editor){
    this.setState({
      memo: {
        ...this.state.memo,
        content: editor
      }
    })
   
  
  }
  rowClick(item){
    this.setState({redirectToShow: true})
    this.setState({ memo: item})

  }

  handleSearchInput(e){
    this.setState({
      searchMemo: {
        ...this.state.searchMemo,
        [e.target.name]: e.target.value
      }
    })
  }

  search(){
    this.setState({load: false})
    const { history } = this.props
    var searchParams = this.getSearchParams().join("&")
    const params = new URLSearchParams()
    params.append("/search", searchParams)
    history.push({ search: searchParams })
    this.loadMemos([this.state.searchUrl, searchParams].join("?"))
  }

  getSearchParams() {
    var searchParams = []
    // This is to load all params based on searchParams state.
    Object.entries(this.state.searchMemo).map(([key, value]) => {
      if (value != '' && value != undefined && value != null) {
        if(key === "employee" && value.id !== undefined && value.id !== null) {
          searchParams.push(['employee_ids', value.id].join("="))
        }else {
          searchParams.push([key, value].join("="))
        }
      }
    })

    return searchParams
  }

  handlePageChange(event, value) {
    var searchParams = this.getSearchParams()
    searchParams.push(["page", value].join("="))
    searchParams = searchParams.join("&")

    const { history } = this.props
    const params = new URLSearchParams()

    params.append("/search", searchParams)
    history.push({ search: searchParams })
    this.setState({ currentPage: value })
    this.loadMemos([this.state.searchUrl, searchParams].join("?"))
  }


  clearSearch(){
    this.setState({searchMemo: {created_at_from: '',created_at_to: '',title:'',content: '',sent: '',employee: null}})
    const { history } = this.props
    history.push({ search: '' })
    this.setState({ withResultsLabel: false})

    this.loadMemos(this.state.searchUrl)
  }
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.search()
    }
  }
  handleEmployees(event,values){
    this.setState({
      searchMemo: {
        ...this.state.searchMemo,
        employee: values
      }
    })
  }

  handleShowPopup(item){
    this.setState({ showPopup: true, memo: item })
  }

  render() {

    if(this.state.redirectToShow){
      return (<Redirect to={{
        pathname: '/memos/' + this.state.memo.id
      }} />)
    }
    return (
      <>
        {
          this.state.load ? (
            <div>
              <MemoSearchForm
              employees={this.state.employees}
              item={this.state.searchMemo}
              handleChange={this.handleSearchInput}
              search={this.search}
              clearSearch={this.clearSearch}
              handleKeyPress={this.handleKeyPress}
              handleAutocomplete={this.handleEmployees}
              />

              <AnnouncementTable
                items={this.state.memos}
                icon={<AllInboxIcon fontSize="large" />}
                model="Incident Report"
                handleClick={this.handleCreateorUpdateItem}
                initialItem={this.state.initialMemo}
                onOpenDeletePopup={this.handleOpenDeletePopup}
                rowClick={this.rowClick}
                withPagination={true}
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                handlePageChange={this.handlePageChange}
                handleShowPopup={this.handleShowPopup}
              />

              <SimplePopUp
                openPopup={this.state.openPopup}
                title={this.state.title}
                items={this.state.memos}
                handleClose={this.handleClose}
                maxWidth="xl"
              >
                <MemoForm
                 error={this.state.errorMessages}
                 item={this.state.memo}
                 submit={this.handleSubmit}
                 handleChange={this.handleInputChange}
                 employees={this.state.employees}
                 selectedEmployees={this.state.selectedEmployees}
                 handleAutocomplete={this.handleAutocomplete}
                 handleEditor={this.handleEditor}
                 onAttachmentAdd={this.onAttachmentAdd}
                 currentUser={this.props.currentUser}
                 officer={this.state.officer}
                 />
              </SimplePopUp>

              <SimplePopUp
                openPopup={this.state.showPopup}
                title={this.state.memo.title}
                handleClose={this.handleClose}
                maxWidth="lg"
              >
                <Memo item={this.state.memo} />
              </SimplePopUp>


              <SimpleDeletePopUp
                openDeletePopup={this.state.openDeletePopup}
                item={this.state.memo}
                delete={this.handleDeleteItem}
                handleDeleteClose={this.handleClose}
                model={this.state.model}
              />
              <AlertMessage
                notify={this.state.notify}
                handleCloseAlert={this.handleCloseAlert}
                isOpen={this.state.isOpen}
                type={this.state.type}
                message={this.state.message}
              />
            </div>
          ) : (
            <ProgressBar model={this.state.model}/>
          )}
      </>
    )
  }
}

export default withRouter(Memos)
Memos.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  currentUser: PropTypes.object
}
